import React, { ReactElement } from "react";
import { CSVLink } from "react-csv";
import { FileExcelOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { GraphCSVProps } from "../../../wrappers/LoadingGraph";

const AdsByWeekYoYCSV = ({ data, countKey }: GraphCSVProps): ReactElement => {
  const headers = [
    {
      label: "Year",
      key: "year",
    },
    {
      label: "Week",
      key: "week",
    },
    {
      label: "Count",
      key: countKey ? countKey : "total",
    },
  ];

  return (
    <CSVLink data={data} headers={headers}>
      <Button type="dashed" icon={<FileExcelOutlined />} />
    </CSVLink>
  );
};

export default AdsByWeekYoYCSV;
